export const isValidArray = (arr) => {
  if (!Array.isArray(arr)) return false
  return arr.length > 0
}

export const isObjectEmpty = (object) => {
  if (!object) return false
  return Object.values(object).length >= 0
}